import { FlowStep, GlobalActionType } from './GlobalContextTypes';

type Act<A, AT, P> = (args: A) => { type: AT; payload: P };

interface ActionArgs {
  flowStep: FlowStep;
}

interface AmazonIdArgs {
  amazonId: string;
}

interface GetNotifiedArgs {
  getNotified: {
    brand: string;
    model: string;
  };
}

export const updateFlowStep: Act<
  ActionArgs,
  GlobalActionType.UpdateFlowStep,
  ActionArgs
> = ({ flowStep }) => ({
  type: GlobalActionType.UpdateFlowStep,
  payload: { flowStep },
});

export const updateAmazonId: Act<
  AmazonIdArgs,
  GlobalActionType.UpdateAmazonId,
  AmazonIdArgs
> = ({ amazonId }) => ({
  type: GlobalActionType.UpdateAmazonId,
  payload: { amazonId },
});

export const updateGetNotified: Act<
  GetNotifiedArgs,
  GlobalActionType.UpdateGetNotified,
  GetNotifiedArgs
> = ({ getNotified }) => ({
  type: GlobalActionType.UpdateGetNotified,
  payload: { getNotified },
});

export type GlobalContextAction =
  | ReturnType<typeof updateFlowStep>
  | ReturnType<typeof updateAmazonId>
  | ReturnType<typeof updateGetNotified>;
